import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';


class PublishAssetModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { openModal, closeModal, assetToPublish, handlePublishAsset, publishAssetInProgress } = this.props;
    const { assetParent } = assetToPublish || {};
    const { published } = assetParent || {};
    return (
      <Modal show={openModal === 'PublishAssetModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{published ? 'Disable' : 'Enable'} Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!publishAssetInProgress && published && (
            <div style={{ textAlign: 'center' }}>
              <p>
                Disabling will remove this page from your website.
              </p>
              <p>
                Are you sure you want to disable this page?
              </p>
            </div>
          )}
          {!publishAssetInProgress && !published && (
            <span>Are you sure you want to enable this page?</span>
          )}
          {publishAssetInProgress && (
            <span>Loading ...</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" bsStyle="success" onClick={handlePublishAsset} disabled={publishAssetInProgress}>
            <span className="ti ti-check" />  {published ? 'Disable' : 'Enable'}
          </Button>
          {' '}
          <Button type="button" bsStyle="hollow-info" onClick={closeModal} disabled={publishAssetInProgress}>
            <span className="ti ti-close" /> Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(PublishAssetModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/PublishAssetModal.js